import React from "react";
import AButton from "../../../../common/form-fields-mui/AButton";

const ActionButtons = ({
  saveBtnTitle,
  handleReset,
  handleSave,
  saveDisabled,
  handleViewLogs,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div className="d-flex mt-3">
        <AButton
          variant="primary_filled"
          className="no-ml-btn"
          onClick={handleSave}
          disabled={saveDisabled}
        >
          {saveBtnTitle}
        </AButton>

        <AButton
          variant="outline"
          outlineVariantColor="#CBCBCB"
          textColor="#0F0F0F"
          onClick={handleReset}
        >
          Reset
        </AButton>
      </div>

      <AButton
        variant="link"
        outlineVariantColor="#CBCBCB"
        textColor="#0F0F0F"
        onClick={handleViewLogs}
      >
        View Logs
      </AButton>
    </div>
  );
};

export default ActionButtons;
